import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/regimen";
const API_PATH_2 = ConstantList.API_ENPOINT + "/api/patient-regimen";

export const pagingRegimens = (searchObject) => {
  var url = API_PATH + "/pagingRegimens";
  return axios.post(url, searchObject);
};

export const getRegimen = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRegimen = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRegimen = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRegimen = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (obj) => {
  let url = API_PATH + "/checkCode";
  return axios.post(url, obj);
};

export const getPatientRegimen = (id) => {
  let url = API_PATH_2 + "/etb-patient-regimen/" + id;
  return axios.get(url);
};
